// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useMutation, { type MutationOptions } from '../../useMutation';
import { CognitoMutationDocument, type CognitoMutation, type CognitoMutationVariables } from './CognitoMutation';

export async function getCognitoMutationClient(variables: CognitoMutationVariables) {
  return fetchGraphqlClient<CognitoMutation, CognitoMutationVariables>(CognitoMutationDocument, "CognitoMutation", { variables });
}
export const useCognitoMutation = (options?: MutationOptions) => useMutation<CognitoMutation, CognitoMutationVariables>(getCognitoMutationClient, options);